import {
  AssignmentIndOutlined,
  AssignmentLateOutlined,
  EditNoteOutlined,
} from "@mui/icons-material";
import QuickActionButton from "../shared/QuickActionButton";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { isEmpty } from "lodash";

const QuickActionCompleteProfile = ({ disabled }) => {
  const navigate = useNavigate();
  const profile = useSelector((state) => state?.profile);

  const isComplete = useMemo(() => {
    const associatedEntities = profile?.associatedEntities || [];
    const validatedExperience = profile?.validatedExperience || [];

    if (isEmpty(associatedEntities)) {
      return false;
    }

    if (isEmpty(validatedExperience)) {
      return false;
    }

    return true;
  }, [profile]);

  return (
    <QuickActionButton
      disabled={disabled}
      title={isComplete ? "Edit Your Profile" : "Complete Your Profile"}
      onClick={() => navigate("/profile")}
      description={
        isComplete
          ? "Make sure your profile information is up to date."
          : "Some required profile information is missing from your profile."
      }
      // icon={<EditNoteOutlined className="thin" />}
      icon={<AssignmentIndOutlined className="thin" />}
      badge={!isComplete}
      badgeColor="warning"
      // badgeIcon={
      //   <AssignmentLateOutlined className="thin" sx={{ fontSize: "13px" }} />
      // }
    />
  );
};

export default QuickActionCompleteProfile;
